import { gql } from '@apollo/client/core';

export const CREATE_DSR_REQUEST = gql`
  mutation {
    createDsrRequest(optOut: true) {
      createdAt
    }
  }
`;

export const CREATE_NON_CUSTOMER_DSR_REQUEST = gql`
  mutation createNonCustomerDsrRequest(
    $firstName: String!
    $lastName: String!
    $address: String!
    $city: String!
    $state: String!
    $zip: String!
    $email: String!
    $phone: String!
    $optOut: Boolean!
  ) {
    createNonCustomerDsrRequest(
      firstName: $firstName
      lastName: $lastName
      address: $address
      city: $city
      state: $state
      zip: $zip
      email: $email
      phone: $phone
      optOut: $optOut
    )
  }
`;
